import { useCallback, useEffect, useState } from "react"
import { useParams } from "react-router"
import Footer from "../../components/Footer"
import Navbar from "../../components/Home/Navbar"
import { findAPost } from "../../services/blog"
import { blogNavLinks } from "../../utilities/links"
import smartaLogo from "../../assets/smarta.png"
import { Post } from "../../data-types/data-types"
import Button from "../../components/Widgets/Button"
import Side from "../../components/Blog/Side"
import { animateScroll } from "react-scroll"

const EachPost = () => {
	const [isLoading, setIsLoading] = useState(false); //loading state
	const [errorExist, setErrorExist] = useState(false); /// if there's an error
	const [notExist, setNotExist] = useState(false); // if post does not exist
	const [post, setPost] = useState<Post | null>(null); // post
	const { id } = useParams();

	const getPost = useCallback(async () => {
		setIsLoading(true);
		setErrorExist(false);
		setNotExist(false);
		animateScroll.scrollToTop({ duration: 400 })
		const response = await findAPost(id);
		setIsLoading(false);
		if (response.success) {
			setPost(response.data);
			document.title = `${response.data.title} | SMARTA Blog`
		} else if (response.notExist) {
			setNotExist(true);
		} else if (response.error) {
			setErrorExist(true);
		}

	}, [id])

	useEffect(() => {
		getPost();
		return () => {
			document.title = "SMARTA | Developmental hub for teenagers that thrive!"
		}
	}, [getPost])

	return (
		<>
			<Navbar links={blogNavLinks} filled />
			<section className="flex xl:px-24 md:justify-between sm:px-8 px-5 flex-col md:flex-row md:space-x-10 pt-28 dark:bg-slate-900 text-slate-600 dark:text-slate-300">
				<div className="w-full md:border-r dark:md:border-slate-700 md:pr-10 lg:pr-20">
					{isLoading &&
						<div className="flex min-h-[80vh] justify-center items-center">
							<img src={smartaLogo} alt="smarta logo" className="w-6 animate-ping rm-drag" />
						</div>
					}
					{notExist && !isLoading && !errorExist &&
						<div className="flex min-h-[80vh] flex-col space-y-4 justify-center items-center">
							<p>The resource you requesy for does not exist</p>
							<Button isLink to="/blog" text="Go Home" primary />
						</div>
					}
					{!notExist && !isLoading && errorExist &&
						<div className="flex min-h-[80vh] flex-col space-y-4 justify-center items-center">
							<p className="text-center max-w-sm">An error occured when getting this resource, check your internet connection and try again.</p>
							<Button onClick={getPost} text="Try Again" primary />
						</div>
					}
					{!isLoading && !notExist && !errorExist && post &&
						<div className="mb-10">
							<div className="my-3">
								<span className={`text-xs my-3 mr-2 `}>
									<i className='bx bx-calendar mr-1'></i>
									{post.date}
								</span>
								{/* <span className={`text-xs my-3 `}>
									<i className='bx bx-time mr-1' ></i>
									02 min read
								</span> */}
							</div>
							<h3 className="text-3xl my-8 text-slate-800 font-bold dark:text-white">{post.title}</h3>
							<p className="md:text-lg">{post.description}</p>
							<img src={post.image ?? `https://images.unsplash.com/photo-1676371855313-a56044326d31?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw4fHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60`} alt="postImage" className="max-w-full object-cover bg-slate-200 dark:bg-slate-700 my-8" />
							<div dangerouslySetInnerHTML={{ __html: post.body }} ></div>
						</div>
					}
				</div>
				<Side />
			</section>
			{/* <Subscribe /> */}
			<Footer />
		</>
	)
}

export default EachPost